import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Image from 'next/image';
import Link from 'next/link';
import { DOMAIN_BASE_SHORT, ROUTES } from 'config/Nav';
import useStyles from './styles';
import withLayout from 'hocs/withLayout';
import { PageHeader } from 'molecules';
import { Seo } from '@elevator/ui';

const BANNER_IMAGE =
  'https://elevator-media.imgix.net/app/uploads/2017/03/23104137/daye-jackjpg-950x451.jpg?fm=pjpg&ixlib=php-1.2.1&s=4eac572b0b3b255bf5131a95d242a0a2';

/**
 * Advertising marketing page — hero, copy, and CTA to the campaign flow at /campaign.
 */
const Advertise = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.container} data-layout="advertise" component="main">
      <Seo
        type="website"
        data={{
          baseUrl: DOMAIN_BASE_SHORT,
          title: 'Advertise With ELEVATOR Mag',
          description: 'Submit advertising campaigns to run on the ELEVATOR Ad Network.',
          path: ROUTES.ADVERTISE.to,
        }}
      />
      <PageHeader title="Advertise With Us" divider={true} />
      <Image
        src={BANNER_IMAGE}
        width={1100}
        height={550}
        alt="ELEVATOR Advertising"
        className={classes.image}
        priority
      />
      <Typography>
        ELEVATOR has established itself as one of the leading and most respected
        tastemakers of music & youth culture, generating over 20 million monthly
        impressions across multiple platforms. Our mission is to spotlight the unsung
        talent of the underground. The &lsquo;up next&rsquo;. The people, things and
        brands across the world on the cusp of hitting the tipping point into the
        mainstream of music, fashion, art & design and events. Elevatormag.com reaches
        over 90k unique monthly visitors.
      </Typography>
      <Button
        component={Link}
        href={ROUTES.CAMPAIGN.to}
        variant="contained"
        color="primary"
        size="large"
        className={classes.button}
      >
        Start a campaign
      </Button>
    </Box>
  );
};

export default withLayout(Advertise, { contentWidth: 'md', margin: true });
